import { render, staticRenderFns } from "./LogBooksModule.vue?vue&type=template&id=40cf6912"
import script from "./LogBooksModule.vue?vue&type=script&lang=js"
export * from "./LogBooksModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports